function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '../TextField';
import Box from '../Box';
import { styled } from '../styles';
const RootAutoSelect = styled(Autocomplete)(_ref => {
  let {
    theme
  } = _ref;
  return {
    flex: "1 0 auto",
    display: "inline-flex",
    padding: theme.size.focusWidth
  };
});
const AutoSelect = _ref2 => {
  let {
    error = false,
    disabled = false,
    multiple = false,
    required = false,
    ...props
  } = _ref2;
  const {
    augmentField,
    placeholder,
    label,
    onKeyPress,
    helperText,
    errorText,
    inputProps: restinputProps,
    ...restProps
  } = props;
  const inputProps = {
    error,
    helperText: helperText,
    errorText: errorText,
    required,
    label,
    augmentField,
    placeholder,
    ...restinputProps
  };
  const autoProps = {
    ...restProps,
    // there are other things not yet defined here that we need to pass through such as onInputChanged so we need to pass the rest of props to the control
    disabled,
    required,
    multiple
  };
  return /*#__PURE__*/React.createElement(RootAutoSelect, _extends({}, autoProps, {
    slotProps: {
      paper: {
        elevation: 8
      }
    },
    renderInput: params => {
      const {
        InputProps: ParamInputProps,
        InputLabelProps: ParamInputLabelProps,
        ...restparams
      } = params;
      const {
        InputProps: OriginalInputProps,
        InputLabelProps,
        ...restinputProps
      } = inputProps;
      const InputProps = {
        ...ParamInputProps,
        ...OriginalInputProps,
        InputLabelProps: {
          ...ParamInputLabelProps,
          ...InputLabelProps
        },
        endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, restProps.endAdornment, /*#__PURE__*/React.createElement(Box, {
          sx: {
            position: 'static',
            transform: 'translate(0, 50%)'
          }
        }, params.InputProps.endAdornment))
      };
      const attrs = {
        ...restparams,
        ...restinputProps,
        onKeyUp: onKeyPress
      };
      return /*#__PURE__*/React.createElement(TextField, _extends({}, attrs, {
        InputProps: InputProps,
        InputLabelProps: InputLabelProps
      }));
    }
  }));
};
export default AutoSelect;